<script setup lang="ts">
import PlaceholderPage from './PlaceholderPage.vue'
</script>

<template>
  <PlaceholderPage
    title="Reports"
    description="Utilisation, demand and spend over time."
    icon="chart"
    next="Analytics come after the core booking flow — utilisation per location, most-requested amenities, spend per vessel."
  />
</template>
